import { assign } from 'xstate5';

import { type CustomizationMachineAction } from '../../types';

// ─────────────────────────────────────────────────────────────────────────────

export const resetLastKnowModifications: CustomizationMachineAction = assign(() => {
  return {
    lastKnownModifications: undefined,
    lastKnownMixedDressingDetails: [],
  };
});
